// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1mMD8","empty":"ModalGraph_empty__2gJsQ"};